export const rubrosHistoricos = [
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/Zip/1erTrimestre2025.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/Zip/2doTrimestre2025.zip"
            },
             {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/Zip/3erTrimestre2025.zip"
            },
             {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/Zip/4toTrimestre2025.zip"
            },

        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Transparencia/Zip/1erTrimestre2024.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2024/1erTrimestre2024SADERH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Transparencia/Zip/2doTrimestre2024.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2024/2doTrimestre2024SADERH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Transparencia/Zip/3erTrimestre2024.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2024/3erTrimestre2024SADERH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Transparencia/Zip/4toTrimestre202.zip"
               
            },
        ]
    },

    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/1erTrimestre2023.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2023/1erTrimestre2023SEDAGROH.zip"
            },
             {
                 "trimestre" : "Segundo Trimestre",
                 "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/2doTrimestre2023SADERH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2023/2doTrimestre2023SEDAGROH.zip"
             },
             {
                 "trimestre" : "Tercer Trimestre",
                 "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/3erTrimestre2023.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2023/3erTrimestre2023SEDAGROH.zip"
             },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/4Trimestre2023.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2023/4toTrimestre2023SEDAGROH.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/1erTrimestre2022.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2022/1erTrimestre2022SEDAGROH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/2doTrimestre2022SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2022/2doTrimestre2022SEDAGROH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/3erTrimestre2022SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2022/3erTrimestre2022SEDAGROH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/4Trimestre2022.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2022/4toTrimestre2022SEDAGROH.zip"

            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/1erTrimestre2021.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2021/1erTrimestre2021SEDAGROH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/2doTrimestre2021SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2021/2doTrimestre2021SEDAGROH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/3erTrimestre2021.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2021/3erTrimestre2021SEDAGROH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/4erTrimestre2021.zip"
                //  "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2021/4toTrimestre2021SEDAGROH.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/1erTrimestre2020SEDAGROH.zip"
                //  "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2020/1erTrimestre2020SEDAGROH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/2doTrimestre2020.zip"
                //  "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2020/2doTrimestre2020SEDAGROH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/3doTrimestre2020.zip"
                //  "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2020/3erTrimestre2020SEDAGROH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/4erTrimestre2020.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2020/4toTrimestre2020SEDAGROH.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/1erTrimestre2019SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2019/1erTrimestre2019SEDAGROH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/2doTrimestre2019SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2019/2doTrimestre2019SEDAGROH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/3erTrimestre2019SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2019/3erTrimestre2019SEDAGROH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/4erTrimestre2019SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2019/4toTrimestre2019SEDAGROH.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/1erTrimestre2018SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2018/1erTrimestre2018SEDAGROH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/2doTrimestre2018SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2018/2doTrimestre2018SEDAGROH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/3erTrimestre2018SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2018/3erTrimestre2018SEDAGROH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/4erTrimestre2018SEDAGROH.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/Transparencia/Historico/2018/4toTrimestre2018SEDAGROH.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/zip/21rubros"
            }
        ]
    }
]